import React from 'react';
import { Typography, Box } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { TransparencyPageHeader } from '../styles';

/**
 * TransparencyHeader - Company identity header for public transparency page
 * @param {string} name - Company name
 * @param {string} description - Company description
 * @param {string} lastUpdated - Last update date
 */
export const TransparencyHeader = ({ name, description, lastUpdated }) => {
  return (
    <TransparencyPageHeader>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <VerifiedUserIcon sx={{ fontSize: 48, opacity: 0.9 }} />
      </Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        {name}
      </Typography>
      {description && (
        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: 600, mx: 'auto', mb: 2 }}>
          {description}
        </Typography>
      )}
      <Typography variant="caption" sx={{ opacity: 0.7 }}>
        Centro de Transparência
        {lastUpdated && ` | Atualizado em ${lastUpdated}`}
      </Typography>
    </TransparencyPageHeader>
  );
};
